import type { ReactNode } from 'react'
import { createContext, useContext, useState } from 'react'

type HeaderNavContextType = {
  headerNav: string[] | null
  setHeaderNav: (nav: string[] | null) => void
}

const HeaderNavContext = createContext<HeaderNavContextType>({
  headerNav: null,
  setHeaderNav: () => {},
})

export const useHeaderNav = () => useContext(HeaderNavContext)

export const HeaderNavProvider = ({ children }: { children: ReactNode }) => {
  const [headerNav, setHeaderNav] = useState<string[] | null>(null)

  return (
    <HeaderNavContext.Provider value={{ headerNav, setHeaderNav }}>
      {children}
    </HeaderNavContext.Provider>
  )
}